import styled from 'styled-components';

import { from } from 'styles/media';

import { ReactComponent as Alert } from 'assets/images/icons/alert-triangle.svg';
import { ReactComponent as Quotation } from 'assets/images/icons/quotation.svg';
import { ReactComponent as Envelockets } from 'assets/images/envelockets.svg';
import DefaultLoader from 'components/Loader';
import addAlpha from 'utils/addAlpha';

export const LoginContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.gray1};
  display: grid;
  grid-template-areas:
    'main'
    'footer'
    'aside';
  grid-template-rows: 1fr auto;
  height: 100vh;

  ${from.laptop} {
    grid-template-areas:
      'main aside'
      'footer aside';
    grid-template-columns: 1fr 30rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4rem;
  letter-spacing: -0.0066em;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.gray3};

  ${from.tablet} {
    margin-bottom: 1rem;
  }
`;

export const Footer = styled.footer`
  grid-area: footer;
  font-size: 0.75rem;
  line-height: 0.9375rem;
  text-align: center;

  ${from.smallMobile} {
    margin: 1.5rem 0;
  }
`;

export const Aside = styled.aside`
  position: relative;
  display: none;
  grid-area: aside;
  background: linear-gradient(180deg, #1a4159 0%, #0a4964 100%);
  color: ${({ theme }) => theme.colors.white};
  padding: 2.5rem;
  text-align: center;

  @media (max-height: 46.875rem) {
    padding-top: 8vh;
  }

  @media (min-height: 46.9375rem) and (max-height: 56.25rem) {
    padding-top: 12vh;
  }

  ${from.laptop} {
    display: flex;
    flex-direction: column;
  }
`;

export const AsideBackdrop = styled(Envelockets)`
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
`;

export const Badges = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const Text = styled.p`
  font-size: 1rem;
  letter-spacing: -0.01em;
  line-height: 1.625rem;
  margin: 0 auto;
  max-width: 17.5rem;
  font-family: ${({ theme }) => theme.fonts.lexendDeca};
`;

export const ErrorWrapper = styled.div`
  min-height: 3.5rem;
  line-height: 1.225rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray3};
  margin-bottom: 1.5rem;
`;

export const ErrorContainer = styled.div`
  border: 0.0625rem solid ${({ theme }) => addAlpha(theme.colors.gray2, 0.5)};
  border-radius: 0.125rem;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.625rem;
  text-align: start;

  a {
    color: ${({ theme }) => theme.colors.gray4};
  }

  b {
    font-weight: ${({ theme }) => theme.weights.medium};
  }
`;

export const AlertIcon = styled(Alert)`
  color: ${({ theme }) => theme.colors.yellow700};
  margin-right: 0.6625rem;
`;

export const Loader = styled(DefaultLoader)`
  margin-top: 1rem;
`;

export const NewUsersDescription = styled.span`
  display: block;
  color: ${({ theme }) => addAlpha(theme.colors.gray3, 0.75)};
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const QuoteBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Quote = styled.span`
  position: relative;
  margin-top: 1.875rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: #c3e6f4;
  text-align: left;

  &:first-of-type {
    margin-top: 0;
  }

  &.left {
    margin-right: 2.5rem;

    svg {
      right: -2.5rem;
      transform: rotate(180deg);
    }
  }

  &.right {
    margin-left: 2.5rem;

    svg {
      left: -2.5rem;
    }
  }
`;

export const QuotationIcon = styled(Quotation)`
  position: absolute;
  top: 0;
  width: 1.25rem;
  height: 1.25rem;

  path {
    fill: ${({ theme }) => theme.colors.orange600};
  }
`;
